import jwtDecode from 'jwt-decode'

import type { TokenParam } from 'utils/user'
import type { TokenPayload } from './interface'

export function decodeToken<T>(accessToken: TokenParam): T {
  if (!accessToken) return {} as T

  const decode = jwtDecode<T>(accessToken)

  return decode
}

export function checkTokenExpired(accessToken: TokenParam): boolean {
  let isExpired = true

  if (typeof accessToken !== 'string') {
    return isExpired
  }

  try {
    const accessTokenPayload = decodeToken<TokenPayload>(accessToken)

    if (!accessTokenPayload.exp || Date.now() < accessTokenPayload.exp * 1000) isExpired = false

    return isExpired
  } catch {
    return isExpired
  }
}
